export default __webpack_public_path__ + "static/media/drag.a32e7698.svg";